import { IVoucherOrder } from '@epi-models/shared';

import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';

interface VoucherOrderState {
  voucherOrder: IVoucherOrder | null;
  noPersistance: boolean;
  isError: boolean;
}

interface VoucherDetailsAction {
  voucherDetails: IVoucherOrder;
}

export const getInitialState = (): VoucherOrderState => ({
  voucherOrder: null,
  noPersistance: true,
  isError: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_VOUCHER_ORDER_DETAILS}_REQUEST`]:
    (): Partial<VoucherOrderState> => ({
      voucherOrder: null,
      isError: false
    }),

  [`${ApiConstants.LOAD_VOUCHER_ORDER_DETAILS}_SUCCESS`]: (
    state: VoucherOrderState,
    { voucherDetails }: VoucherDetailsAction
  ): Partial<VoucherOrderState> => ({
    voucherOrder: voucherDetails ? { ...voucherDetails } : null,
    isError: false
  }),

  [`${ApiConstants.LOAD_VOUCHER_ORDER_DETAILS}_FAILURE`]:
    (): Partial<VoucherOrderState> => ({
      voucherOrder: null,
      isError: true
    })
});
